export default __webpack_public_path__ + "static/cactus2-bbe643fa168f89a3634f9bbc8808b98f.webp";